export const customerFields = [
  'id',
  'mobile',
  'name',
  'keyword',
  'labels',
  'status',
  'log_time',
  'log_content',
  'come_time',
  'subject_id',
  'project_id',
  'wechat',
  'wechat_nickname',
  'wechat_status',
  'wechat_add_time',
  'region',
  'area',
  'type',
  'total',
  'price',
  'house_sale',
  'house_region',
  'discount',
  'income',
  'manager',
  'channel',
  'buy_type',
  'money_time',
  'industry',
  'job',
  'job_time',
  'buy_house',
  'financial',
  'introduce',
  'subjects',
  'source_channel_v2', 'total_budget_range', 'price_acceptance_level', 'purpose_v2'
]
export function budgetValues(value) {
  const values = Array.isArray(value) ? value : value === '' || value == null ? [] : String(value).split(',')
  return values.filter(item => typeof item === 'number' || (typeof item === 'string' && /^\d+$/.test(item))).map(Number).filter((item, index, all) => Number.isInteger(item) && item >= 0 && item <= 5 && all.indexOf(item) === index).sort((a, b) => a - b)
}
export function payload(info, content, nextTime) {
  const data = {}
  customerFields.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(info, key)) data[key] = info[key]
  })
  data.log_content = content.trim()
  data.log_time = nextTime ? nextTime.replace('T', ' ') + (nextTime.length === 16 ? ':00' : '') : ''
  return data
}
export function inputDate(value) {
  return value
    ? String(value)
        .slice(0, 16)
        .replace(' ', 'T')
    : ''
}
export function dateText(value) {
  return value
    ? String(value)
        .replace('T', ' ')
        .slice(0, 16)
    : '未设置'
}
export function canCall(mobile) {
  return /^1\d{10}$/.test(String(mobile || ''))
}
export function listParams(search) {
  return {
    order: search.searchOrder,
    start: search.searchStartTime,
    end: search.searchEndTime,
    keyword: search.searchKeyword,
    status: search.searchStatus,
    labels: search.searchLabels,
    subject_type: search.searchSubjectType,
    subjects: search.searchSubjects,
    employees: search.searchEmployees,
    channel: search.searchChannels,
    source_channel_v2: search.searchSourceChannelV2,
    total_budget_range: search.searchTotalBudgetRange,
    price_acceptance_level: search.searchPriceAcceptanceLevel,
    purpose_v2: search.searchPurposeV2
  }
}



// WEBPACK FOOTER //
// ./src/common/customer.js